// Musi być pierwsze — owija window.fetch, żeby dokleić JWT do zapytań /api/* i /crawl4ai/*
// zanim jakikolwiek serwis wystartuje z fetchem.
import './lib/apiAuthInterceptor'

import { createRoot } from 'react-dom/client'
import App from './App.tsx'

// Geist — default shadcn sans (ładowany lokalnie, bez FOUT)
import '@fontsource/geist/400.css'
import '@fontsource/geist/500.css'
import '@fontsource/geist/600.css'
import '@fontsource/geist/700.css'
// Geist Mono — dla code/pre
import '@fontsource/geist-mono/400.css'
import '@fontsource/geist-mono/500.css'
import '@fontsource/geist-mono/600.css'

import './index.css'
// Syntax highlighting dla code blocks w /docs (rehype-highlight)
import 'highlight.js/styles/github-dark.css'

createRoot(document.getElementById("root")!).render(<App />);
